import { FormGroup } from "@angular/forms";
import { BaseFormViewModel } from "./base-form.view-model";

export class NotImplementedViewModel extends BaseFormViewModel {
    toFormGroup(): FormGroup {
        return new FormGroup({
        })
    }

    toFormModel() {
        return;
    }

    static fromFormModel(formModel: any): any {
        return;
    }
}
